module.exports = __webpack_public_path__ + "static/img/Bachelor_010279.a299d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010279.jpg
// module id = 137
// module chunks = 0